var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        justify: "center",
        value: _vm.value,
        persistent: "",
        "max-width": "400",
      },
    },
    [
      _c("v-card", { attrs: { color: "#fafafa" } }, [
        _c(
          "section",
          { staticClass: "ma-0 pa-6" },
          [
            _c(
              "v-row",
              { attrs: { justify: "center" } },
              [
                _c("v-icon", { attrs: { "x-large": "", color: "red" } }, [
                  _vm._v("mdi-trash-can-outline"),
                ]),
              ],
              1
            ),
            _c("v-row", { attrs: { justify: "center" } }, [
              _c("span", { staticClass: "pa-4" }, [
                _vm._v(" Delete the selected recap addition? "),
              ]),
              _c("span", { staticClass: "pa-4" }, [
                _vm._v(
                  " Last Updated: " +
                    _vm._s(
                      _vm.formatDateTime(_vm.selectedRecapAddition.updated_on)
                    ) +
                    " "
                ),
              ]),
              _c("span", { staticClass: "pa-4" }, [
                _vm._v(
                  " Warning: This action cannot be undone. Deletion of this recap addition record means it will not be reflected on the next retailer period statement. "
                ),
              ]),
            ]),
            _c(
              "v-row",
              { staticClass: "pa-4", attrs: { justify: "center" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { text: "", height: "40" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$emit("update:value", false)
                      },
                    },
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "white--text ml-4",
                    attrs: { color: "#0c67a5", height: "40" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteRecapAddition(
                          _vm.selectedRecapAddition.recap_addition_id
                        )
                      },
                    },
                  },
                  [_vm._v(" Confirm ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }